import {ErrorHandler} from '@angular/core';
import {ErrorHandler as AbydosErrorHandler} from '@abydos-angular/core';
import {ErrorMessage, InfoMessage, WarningMessage} from '@abydos-angular/primeng';
import {MessageService} from 'primeng/api';

export class PrimeNGMessageErrorHandler extends ErrorHandler implements AbydosErrorHandler {

    constructor(private messageService: MessageService) {
        super();
    }

    override handleError(error: any) {
        this.error(error);
    }

    error(message: string): void {
        this.messageService!.add(new ErrorMessage(message));
    }

    info(message: string): void {
        this.messageService!.add(new InfoMessage(message));
    }

    warning(title: string, message: string): void {
        this.messageService!.add(new WarningMessage(title, message));
    }
}

